import { getRedirectUrl } from '../utils/auth'
import { useUserStore } from '../stores/userStore'

export default function useGuestLogin() {
  async function getGuestTokens() {
    const { helpers, shopperLogin } = useShopper()
    // The SDK's CJS/ESM interop shape differs between dev and production builds (see
    // plugins/commerce.ts), so this can throw synchronously or resolve to a non-thenable that never
    // rejects — hence try/catch plus an explicit shape check rather than trusting a successful await.
    try {
      const tokens = await helpers.loginGuestUser(shopperLogin, {
        redirectURI: getRedirectUrl(),
      })
      if (!isValidTokenResponse(tokens)) throw new Error('Malformed guest token response')
      return tokens
    } catch (e) {
      console.warn('getGuestTokens error', new Error('Failed to log in guest user', { cause: e }))
      return null
    }
  }

  async function getAndSetGuestTokens(): Promise<boolean> {
    const authGeneration = useState<number>('_auth_generation', () => 0)
    const gen = authGeneration.value

    const tokens = await getGuestTokens()
    if (!tokens) return false

    // A concurrent logout() bumps authGeneration while this is in flight — discard a stale response
    // rather than writing cookies/state a newer generation already cleared.
    if (authGeneration.value !== gen) return false

    setAuthCookies({
      refreshToken: tokens.refresh_token,
      accessToken: tokens.access_token,
      expiresIn: tokens.expires_in,
      refreshTokenExpiresIn: tokens.refresh_token_expires_in,
    })
    const userStore = useUserStore()
    userStore.setGuestUser(tokens)
    return true
  }

  return { getGuestTokens, getAndSetGuestTokens }
}
